import React from 'react';
import LiveTile, { type Tile } from 'components/LiveTile';

interface LargeLiveTileProps {
  tile: Tile;
  path: string;
  onClick?: React.MouseEventHandler<HTMLElement>;
}

const LargeLiveTile = (props: LargeLiveTileProps) => (
  <div className="dynamicLobby__liveTile dynamicLobby__liveTile--large">
    <LiveTile {...props} isolateTouch />
  </div>
);

export default LargeLiveTile;
